import React, { useState } from "react";
import { useTheme } from "../../contexts/ThemeContext";

const Input = ({
  label,
  type = "text",
  placeholder,
  value,
  onChange,
  onFocus,
  onBlur,
  disabled = false,
  error,
  helperText,
  required = false,
  fullWidth = true,
  className = "",
  ...props
}) => {
  const { theme } = useTheme();
  const [isFocused, setIsFocused] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleFocus = (e) => {
    setIsFocused(true);
    onFocus && onFocus(e);
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    onBlur && onBlur(e);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const inputStyles = {
    width: fullWidth ? "100%" : "auto",
    padding: "12px 16px",
    fontSize: "16px",
    color: theme.text,
    backgroundColor: theme.surface,
    border: `1px solid ${error ? theme.error : isFocused ? theme.primary : theme.border}`,
    borderRadius: "8px",
    outline: "none",
    transition: "all 0.2s ease",
    opacity: disabled ? 0.6 : 1,
    cursor: disabled ? "not-allowed" : "text",
    marginBottom: className === "profile" && "12px",
  };

  const labelStyles = {
    display: "block",
    marginBottom: "4px",
    fontSize: "14px",
    fontWeight: "500",
    color: theme.text,
  };

  const containerStyles = {
    position: "relative",
    width: fullWidth ? "100%" : "auto",
  };

  const errorStyles = {
    marginTop: "4px",
    fontSize: "12px",
    color: theme.error,
  };

  const helperStyles = {
    marginTop: "4px",
    fontSize: "12px",
    color: theme.textSecondary,
  };

  const passwordButtonStyles = {
    position: "absolute",
    right: "12px",
    top: className === "profile" ? "40%" : "50%",
    transform: "translateY(-50%)",
    background: "none",
    border: "none",
    cursor: "pointer",
    color: theme.textSecondary,
    fontSize: "14px",
    padding: "4px",
  };

  return (
    <div style={containerStyles} className={className}>
      {label && (
        <label style={labelStyles}>
          {label}
          {required && <span style={{ color: theme.error }}>*</span>}
        </label>
      )}

      <div style={{ position: "relative" }}>
        <input
          type={type === "password" && showPassword ? "text" : type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          disabled={disabled}
          style={inputStyles}
          {...props}
        />

        {type === "password" && (
          <button
            type="button"
            onClick={togglePasswordVisibility}
            style={passwordButtonStyles}
            tabIndex={-1}
          >
            {showPassword ? "👁️" : "👁️‍🗨️"}
          </button>
        )}
      </div>

      {error && <div style={errorStyles}>{error}</div>}
      {helperText && !error && <div style={helperStyles}>{helperText}</div>}
    </div>
  );
};

export default Input;
